import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MaterialSelect from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';

const Select = (props) => {
    return (
        <FormControl className={props.className} variant="outlined" size="small" fullWidth={props.fullWidth}>
            {(props.label)
                ? <InputLabel className="fix" shrink={true}><span>{props.label}</span></InputLabel>
                : null
            }
            <MaterialSelect displayEmpty={true}
                            value={props.value} onChange={props.onChange}
                            error={props.error}
                            onFocus={props.onFocus}

            >
                {props.showEmpty
                    ? <MenuItem value="">----------</MenuItem>
                    : null
                }
                {props.options.map((option, id) => (
                    <MenuItem key={id} value={option.value}>{option.title}</MenuItem>
                ))}
            </MaterialSelect>
            {(props.error && props.helperText)
                ? <FormHelperText error={true}>{props.helperText}</FormHelperText>
                : null
            }
        </FormControl>
    );
};

Select.propTypes = {
    className: PropTypes.string,
    options: PropTypes.array.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    onFocus: PropTypes.func,
    fullWidth: PropTypes.bool,
    label: PropTypes.string,
    showEmpty: PropTypes.bool,
};

Select.defaultProps = {
    className: '',
    fullWidth: true,
    showEmpty: true,
};

export default Select;
